import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo">
          <Link to="/">
            <img src="/ExplorezRQM_LogoHoriz_coul.svg" alt="Logo Explorez RQM" />
          </Link>
        </div>
        
        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={`menu-icon ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
        
        <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <Link to="/" className="nav-link">Accueil</Link>
            </li>
            <li className="nav-item">
              <Link to="/directory" className="nav-link">Répertoire</Link>
            </li>
            {currentUser ? (
              <>
                <li className="nav-item">
                  <Link to={`/profile/${currentUser.id}`} className="nav-link">Mon profil</Link>
                </li>
                {/* <li className="nav-item">
                  <Link to="/profile/settings" className="nav-link">Paramètres</Link>
                </li> */}
                {currentUser.isAdmin && (
                  <li className="nav-item">
                    <Link to="/admin" className="nav-link admin-link">Administration</Link>
                  </li>
                )}
                <li className="nav-item">
                  <button onClick={handleLogout} className="btn btn-outline btn-sm">Déconnexion</button>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link to="/login" className="nav-link">Se connecter</Link>
                </li>
                <li className="nav-item">
                  <Link to="/register" className="btn btn-primary btn-sm nav-font-size">S'inscrire</Link>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
